import React from 'react'

import {
  BarcodeField,
  FieldSpec,
  LinkedField,
  PaginatedTable,
  ValueField,
} from 'src/components/Table'
import { ListTableProps } from './types'

const fieldOptions: { [key:string]: FieldSpec } = {
  numUnits: { id: 'numUnits', label: 'Number of Units', renderer: LinkedField(ValueField) },
  primaryBarcode: {
    id: 'primaryBarcode',
    label: 'Primary Barcode',
    ordering: 'primary_barcode__barcode',
    renderer: BarcodeField,
  },
}

export const CaseListTable = (props: ListTableProps) => {
  const { paginator, fields, extraActions, exportConfig } = props

  return (
    <>
      <PaginatedTable
        title="Cases"
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        actions={extraActions}
        exportConfig={exportConfig}
      />
    </>
  )
}
